import { Button, Divider, Space } from "antd";
import React from "react";

export const StyledButtonSHB = () => {
    return (
        <>
            <div>
                <Divider orientation="left">Default Buttons</Divider>

                <Space>
                    <Button>Default Button</Button>

                    <Button type="primary">Primary Button</Button>

                    <Button type="dashed">Dashed Button</Button>

                    <Button type="text">Text Button</Button>

                    <Button type="link">Link Button</Button>
                </Space>

                <Divider orientation="left">Normal Button - 48</Divider>

                <Space>
                    <Button className="CustomButton" type="prime" > Custom Button </Button>

                    <Button className="CustomButton" type="prime-outlined" > Custom Button </Button>

                    <Button className="CustomButton" type="prime-dashed" > Custom Button </Button>

                    <Button className="CustomButton" type="prime-text" > Custom Button </Button>

                    <Button className="CustomButton" type="link"> Link Button </Button>
                </Space>


                <Divider orientation="left">Large Button - 56</Divider>
                <Space>
                    <Button className="CustomButton" type="prime" size="large" > Custom Button </Button>

                    <Button className="CustomButton" type="prime-outlined" size="large" > Custom Button </Button>

                    <Button className="CustomButton" type="prime-dashed" size="large" > Custom Button </Button>

                    <Button className="CustomButton" type="prime-text" size="large" > Custom Button </Button>

                    <Button type="link" className="CustomButton" size="large" > Link Button </Button>
                </Space>




                <Divider orientation="left">Rounded Buttons</Divider>
                <Divider orientation="left">Icon Buttons</Divider>
                <Divider orientation="left">Disable Buttons</Divider>
            </div>
        </>
    )
}